<template>
    <b-modal
        :id="modalId"
        v-model="openModal"
        class="modal-demo"
        title-class="text-light"
        header-bg-variant="dark"
        header-text-variant="light"
        title-tag="h4"
        size="lg"
        :hide-footer="true"
        @show="openModalHandler"
        @hide="hideModal"
    >
        <template #modal-title>
            Residential rating results:
        </template>

        <div class="p-4 modal-body">
            <div class="pb-4">
                <chart
                    :series="ratingPercentageSeries"
                    :options="ratingPercentageOptions"
                    title="Overall rating percentage"
                    class="p-3 card"
                />
            </div>
            <awesome-table
                :options="options"
                :labels="labels"
                :items="results"
                :get-row-class="getRowClass"
            />
        </div>
    </b-modal>
</template>

<script>
import Chart from '@/components/general/Chart';

export default {
    components: {
        Chart
    },

    props: {
        calculationRequestResults: {
            type: Array,
            required: false,
            default: () => []
        },
        modalId: {
            type: String,
            required: false,
            default: 'calculationRequestResultsModal'
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            results: null,
            rankBasedColors: {
                'A+': '#009746',
                A: '#54af3a',
                B: '#c7d20a',
                C: '#feed01',
                D: '#fbba00',
                E: '#ee681f',
                F: '#e31e25'
            },
            openModal: false,
            options: {
                addButton: false,

                searchInput: false,

                clickableRows: false,

                pagination: false
            },
            labels: [
                { value: 'floorNumber', width: '33.33%' },
                { value: 'unitNumber', width: '33.33%' },
                { value: 'rank', width: '33.33%' }
            ]
        };
    },

    computed: {
        ratingPercentageSeries() {
            const series = [];

            const ranks = [
                ...new Set(
                    this.calculationRequestResults.map(result => result.rank)
                )
            ];

            for (const rank of ranks) {
                const count = this.calculationRequestResults.filter(
                    nextResult => nextResult.rank === rank
                ).length;

                series.push(count);
            }

            return series;
        },

        ratingPercentageOptions() {
            const ranks = [
                ...new Set(
                    this.calculationRequestResults.map(result => result.rank)
                )
            ];

            const sortRanks = (a, b) =>
                (a[1] || b[1]) && a[0] === b[0]
                    ? a[1]
                        ? -1
                        : 1
                    : a > b
                    ? 1
                    : -1;

            const colors = ranks
                .sort(sortRanks)
                .map(rank => this.rankBasedColors[rank]);

            return {
                labels: ranks,
                colors,
                tooltip: {
                    fillSeriesColor: false
                }
            };
        }
    },

    watch: {
        isOpen() {
            this.openModal = this.isOpen;
        }
    },

    methods: {
        hideModal() {
            this.$bvModal.hide(this.modalId);
            this.$emit('close');

            this.results = [];
        },

        getRowClass(item) {
            return item.rank === 'A+'
                ? 'building-rating-A-plus'
                : `building-rating-${item.rank}`;
        },

        async openModalHandler() {
            this.results = this.calculationRequestResults
                ? this.calculationRequestResults
                : [];
        },

        rankOccurences(results, rank) {
            results.reduce(
                (occurrence, result) =>
                    result.rank === rank ? occurrence + 1 : occurrence,
                0
            );
        }
    }
};
</script>
